(function() {
'use strict';

angular
    .module('parking')
    .controller('Parking', Parking);

function Parking($filter,
                 $routeParams,
                 $scope,
                 arrayUtil,
                 basketService,
                 basketStore,
                 broker,
                 extraProductsService,
                 parkingDetailsService,
                 scrollService,
                 tripService,
                 flightsTerminalService) {
    const ap = this;

    ap.noneParking = '-1';

    ap.currentParkingLimit = ap.parkingLimit = 5;

    ap.parkingAvailabilityBusy = true;

    broker.subscribe('Parking', 'parkingRequestFailed', function() {
        ap.showDetailsError = true;
        ap.parking = angular.copy(ap.noneParking);
    });

    $scope.$on('$destroy', () => {
        broker.unsubscribe('Parking');
    });

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const basketId = trip.BasketId;
        const tripId = trip.TripId;
        let parkingSearchId = trip.ParkingRequest ? trip.ParkingRequest.AvailabilitySearchId : null;
        const onewayonly = trip.FlightsRequest.OneWayOnly;

        basketStore.parking(basketId, $routeParams.productId).then(function(results) {
            const parking = results ? results.Details.AirportParkingQuoteId : null;
            if (parking) {
                ap.parking = angular.copy(parking);
            } else if (TRPCONFIG.Domain.DefaultAirportParkingSelection) {
                ap.parking = ap.noneParking;
            }

            if (TRPCONFIG.Domain.AirportParkingEnabled && !onewayonly) {
                basketService.getParkingQuotes(parkingSearchId, basketId, tripId).then(function(parkingQuotes) {
                    const setResults = function(results) {
                        ap.parkingQuotes = results;
                        _updateSubtitle();
                        ap.parkingAvailabilityBusy = false;

                        $scope.$watch('ap.parking', function(val) {
                            if (val == null) {
                                return;
                            }
                            _updateSubtitle();

                            if (TRPCONFIG.Domain.EnforceParkingOptionSelection && results.length > 0) {
                                $scope.$emit('sendParkingSelection', val);
                            } else {
                                $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                            }

                            if (val !== ap.noneParking) {
                                const quote = arrayUtil.first(ap.parkingQuotes, function(q) {
                                    return angular.equals(q.QuoteId, val);
                                });
                                if (quote) {
                                    quote.parkingBusy = !quote.Details;
                                    ap.showDetailsError = false;
                                    tripService.getTrip(tripId).then(function(t) {
                                        parkingSearchId = t.ParkingRequest.AvailabilitySearchId;
                                        basketService.selectParking(val, parkingSearchId, basketId).then(function(d) {
                                            ap.showDetailsError = false;
                                            quote.Details = d.Details;
                                            quote.parkingBusy = false;
                                            quote.viewDetails = true;
                                            basketService.updateBasket();
                                        }, function() {
                                            quote.parkingBusy = false;
                                            quote.showDetailsError = true;
                                        });
                                    });
                                } else {
                                    ap.parking = ap.noneParking;
                                }
                            } else {
                                basketStore.removeParking(basketId).then(basketService.updateBasket);
                            }
                        }, true);
                    };

                    if (parkingQuotes && parkingQuotes.length) {
                        parkingQuotes = arrayUtil.sort(parkingQuotes, 'Price');
                        setResults(parkingQuotes);
                    } else {
                        ap.parkingAvailabilityBusy = false;
                        $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                    }
                }, function() {
                    ap.parkingAvailabilityBusy = false;
                    $scope.$emit('sendParkingSelection', { CarParkCode: '0', SupplierId: 0 });
                });
            }
        }).then(null, basketService.restartHolidayWorkflow);

        // get flight departure terminal
        basketStore.flight(trip.BasketId).then(function(flight) {
            const leg = flight.Details.Itinerary.Legs[0];
            flightsTerminalService.getTerminalForFlight(
                leg.DepartureAirport.Code,
                leg.Segments[0].FlightNumber,
                leg.DepartureDate
            )
            .then(terminal => {
                if (terminal) {
                    ap.terminal = terminal;
                }
            });
        });

        ap.appendDetails = function(quote, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            tripService.getTrip(tripId
                ).then(trip => parkingDetailsService.appendDetails(quote, angular.copy(trip))
                ).then(() => { ap.currentInfo = quote; });
        };

        ap.showMoreOrLess = function() {
            const moreParkingQuotes = ap.currentParkingLimit !== ap.parkingQuotes.length;
            const currentParkingLimit = moreParkingQuotes ? ap.parkingQuotes.length : 5;

            if (!moreParkingQuotes) {
                scrollService.scrollTo('#parking-product-expander', { animate: true, offset: 70 }).then(function() {
                    ap.moreParkingQuotes = false;
                    ap.currentParkingLimit = currentParkingLimit;
                });
            } else {
                ap.moreParkingQuotes = true;
                ap.currentParkingLimit = currentParkingLimit;
            }
        };

        ap.filterQuotes = extraProductsService.filterQuotes;

        function _updateSubtitle() {
            if (ap.parkingQuotes && ap.parking) {
                const parkingQuote = arrayUtil.first(ap.parkingQuotes, function(p) {
                    return angular.equals(p.QuoteId, ap.parking);
                });
                ap.parkingQuoteDescription = parkingQuote ? `${parkingQuote.CarPark} (${$filter('customCurrency')(parkingQuote.Price)})` : null;
            }
        }
    }, basketService.bookingAlreadyDone(`parking: '${$routeParams.tripId}'`));
}
})();
